// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreReturns = (client) => ({
    /**
     * `GET /store/returns`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreListReturns
     * @source packages/modules/b2c-core/src/api/store/returns/route.ts
     */
    list: (query, headers) => client.fetch("/store/returns", { method: "GET", query, headers }),
    /**
     * `GET /store/returns/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreReturnsIdRetrieve
     * @source packages/modules/b2c-core/src/api/store/returns/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/store/returns/:id", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=returns.js.map